import { render, staticRenderFns } from "./EditStep1PriceIndication.vue?vue&type=template&id=d1928446&scoped=true"
import script from "./EditStep1PriceIndication.vue?vue&type=script&lang=js"
export * from "./EditStep1PriceIndication.vue?vue&type=script&lang=js"
import style0 from "./EditStep1PriceIndication.vue?vue&type=style&index=0&id=d1928446&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1928446",
  null
  
)

export default component.exports